import React from 'react';
import { Box, Grid } from '@mui/material';
import { ButtonUI, DialogUI } from '../../Interface';
import AlertFormUsersTable from './AlertFormUsersTable';
import AlertFormSchedule from './AlertFormSchedule';

const AlertFormDialog = (props) => {
  const { open, onClose, autocompleteData, name } = props;

  const label = `Riasztás részletei - ${name}`;
  const relevantUsers = autocompleteData?.user.filter((user) => user.archive === 'N' && user.deletedBy === null);

  return (
    <DialogUI open={open} onClose={onClose} headerContent={label} maxWidth="lg" fullWidth>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <AlertFormUsersTable users={relevantUsers} />
        </Grid>

        <Grid item xs={12} md={4} container alignItems="center">
          <AlertFormSchedule />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI text="Ok" className="bg-success" onClick={onClose} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default AlertFormDialog;
